
function formatMoney(value) {
  if (!value) return '0.00'
  // 将数据分割，保留两位小数
  value = Number(value).toFixed(2)
  // 获取整数部分
  const intPart = Math.trunc(value)
  // 整数部分处理，增加,
  const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
  // 预定义小数部分
  let floatPart = '.00'
  // 将数据分割为小数部分和整数部分
  const newArr = value.toString().split('.')
  if (newArr.length === 2) { // 有小数部分
    floatPart = newArr[1].toString() // 取得小数部分
    return intPartFormat + '.' + floatPart
  }
  return intPartFormat + floatPart
}



// 给小于10的数字补 0
function pairNum(num) {
  return (String(num).length == 1 ? '0' : '') + num;
}

// 对传入时间进行转换
const shiftTime = datestamp => {

  if (!datestamp) return;

  // timestamp

  let timestamp =  new Date(datestamp.replace(/-/g, '/')).getTime() / 1000;
  // console.log(timestamp)

  var curTimestamp = parseInt(new Date().getTime() / 1000); //当前时间戳
  var timestampDiff = curTimestamp - timestamp; // 参数时间戳与当前时间戳相差秒数

  var curDate = new Date(curTimestamp * 1000); // 当前时间日期对象
  var tmDate = new Date(timestamp * 1000);  // 参数时间戳转换成的日期对象

  var Y = tmDate.getFullYear(), m = tmDate.getMonth() + 1, d = tmDate.getDate();
  var H = tmDate.getHours(), i = tmDate.getMinutes(), s = tmDate.getSeconds();
  if (timestampDiff < 60) { // 一分钟以内
    return "刚刚";
  } else if (timestampDiff < 3600) { // 一小时前之内
    return Math.floor(timestampDiff / 60) + "分钟前";
  } else if (curDate.getFullYear() == Y && curDate.getMonth() + 1 == m && curDate.getDate() == d) {
    return '今天';
    // return '今天' + pairNum(H) + ':' + pairNum(i);
  } else {
    var newDate = new Date((curTimestamp - 86400) * 1000); // 参数中的时间戳加一天转换成的日期对象
    if (newDate.getFullYear() == Y && newDate.getMonth() + 1 == m && newDate.getDate() == d) {
        return '昨天' + pairNum(H) + ':' + pairNum(i);
    } else if (curDate.getFullYear() == Y) {
      return pairNum(m) + '-' + pairNum(d) + ' ' + pairNum(H) + ':' + pairNum(i);
    } else {
      return Y + '-' + pairNum(m) + '-' + pairNum(d) + ' ' + pairNum(H) + ':' + pairNum(i);
    }
  }
};

export default {
  formatMoney,
  shiftTime
}